import React from 'react';
import MaterialTable from '@material-table/core';
import { withStyles } from '@mui/styles';
import TablePagination from '@mui/material/TablePagination';
import BottonDeAtras from 'components/TablaPersonalizada/BotonDeAtras';
import BotonDeAccion from 'components/TablaPersonalizada/BotonDeAccion';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import DatosDeTabla from './DatosDeTabla';
import ListaDeAcciones from './ListaDeAcciones';
import {styles} from './estilos';
import './estilos.css'

function TablaPersonalizada(props) {
    const { classes, showPagination, pageSize } = props;
    const [modalParams, setModalParams] = React.useState({'open':false,'handler':null,'data':null});
    const tableData =  new DatosDeTabla();
    const actionList = new ListaDeAcciones(props,setModalParams);

    const closeModal=(option)=>{
        setModalParams({'open':false});
        if (option) modalParams.handler(modalParams.data);
    }

    const getdata= async (query,header,service)=>{
        tableData.setQuery(query);
        tableData.setHeader(header);
        tableData.setService(service);

        if(props.obtenerDatos) {
            let prueba = await tableData.getPromiseResponse();
            props.obtenerDatos(prueba);
            return prueba;
        }

        return tableData.getPromiseResponse();
    }

if (props.data === undefined && props.service === undefined) return null 
else return (
    <div className={classes.root}>
        <div className={classes.container}>
            <ModalDeConfirmacion open={modalParams.open} data={modalParams.data} handler={modalParams.handler} closeModal={closeModal} message={modalParams.message}/>
            <MaterialTable
                localization={{
                    toolbar: {searchPlaceholder: "Buscar",searchTooltip: "Buscar "},
                    pagination:{
                        labelRowsSelect:"Registros",labelRowsPerPage:"Filas por pagina",
                        labelDisplayedRows: 'Registros {from} al {to} de {count}',
                        previousTooltip:'Pagina anterior', nextTooltip:'Página siguiente', lastTooltip:'Última página', firstTooltip:'Primera página'
                    },
                    body: {
                        deleteTooltip: "Eliminar",
                        emptyDataSourceMessage: "No existen registros"
                    },
                    header:{ actions: 'Opciones'}
                }}
                title={props.title!==undefined ? props.title: "Listado de registros"}
                columns={props.header}
                data={ (props.service!== undefined) ? query => getdata(query,props.header, props.service) : props.data }
                detailPanel={ (props.detailPanel!==undefined) ?  props.detailPanel : [] }
                actions={ actionList.getList(props.nameToolTipAdd) }
                options={{
                    debounceInterval: 1500,
                    pageSize,
                    pageSizeOptions: [5, 10, 20, 30 ,50, 75, 100 ],
                    toolbar: true,
                    paging: true,
                    actionsColumnIndex: -1,
                    headerStyle: { backgroundColor: '#205690', color: '#FFF' },
                    selection: props.selection,
                    selectionProps: rowData => ({
                        disabled: rowData.idEstadoMovimiento !== props.validationSelectionProps,
                        color: 'primary',
                    })
                }}
                onSelectionChange={ (rows, item) => props.onSelectionChange(rows, item) }
                components={{
                    Action: props => {
                        if (props.action.position==="toolbar") return <BottonDeAtras icon={props.action.icon} tooltip={props.action.tooltip} onClick={props.action.onClick} disabled={props.action.disabled} />
                        else {
                            var element= props.action.action(props.data);
                            return ( <BotonDeAccion tooltip={element.tooltip}  onClick={element.onClick} icon={element.icon} /> )
                        }
                    },
                    Pagination: props => {
                        if(showPagination) {
                            return (
                                <TablePagination
                                    {...props}
                                    SelectProps={{
                                    style:{
                                        fontSize: 14,
                                    }
                                    }}
                                />
                            )
                        }
                        return null
                    }
                }}
                className={classes.table}
            >
            </MaterialTable>
        </div>
    </div>
    );
}

TablaPersonalizada.defaultProps = {
    showSearcher : false,
    showPagination: true,
    pageSize: 10,
    onSelectionChange: () => {},
    selection: false,
    validationSelectionProps: "",
}

export default withStyles(styles)(TablaPersonalizada);
